import t, { forwardRef as T, useState as u, useLayoutEffect as A, useEffect as v } from "react";
import { useTheme as B, Box as r, Typography as I } from "@mui/material";
import { s as L, u as l, c as O, A as k, a as z, b as f } from "./chunk.CYIRpff0.js";
const _ = T((e, h) => {
  const n = B(), i = L(e.severity, n, !0), [c, x] = u(!1), [W, g] = u(), [y, s] = l(
    e.actionOne
  ), [w, d] = l(
    e.actionTwo
  ), [C, o] = l(
    e.onClose
  ), [E, a] = l(W, !0);
  A(() => {
    a > 0 && e.actionOne && x(
      O(
        e.title,
        n,
        s,
        a,
        o,
        d
      )
    );
  }, [
    e.title,
    s,
    a,
    o,
    d
  ]), v(() => {
    const m = () => {
      g(window.innerWidth);
    };
    return window.addEventListener("resize", m), () => {
      window.removeEventListener("resize", m);
    };
  }, []);
  const b = () => /* @__PURE__ */ t.createElement(
    r,
    {
      display: "flex",
      sx: {
        float: "right",
        marginLeft: "auto",
        minWidth: 0,
        maxWidth: "100%",
        gap: n.spacing(1)
      }
    },
    /* @__PURE__ */ t.createElement(
      f,
      {
        ctaRef: y,
        action: e.actionOne,
        shouldWrap: c || !!e.description,
        bannerCTA: !0,
        isPrimary: !0
      }
    ),
    e.actionTwo && /* @__PURE__ */ t.createElement(
      f,
      {
        ctaRef: w,
        action: e.actionTwo,
        shouldWrap: c || !!e.description,
        bannerCTA: !0
      }
    )
  ), R = () => /* @__PURE__ */ t.createElement(
    r,
    {
      sx: {
        backgroundColor: i.color,
        padding: n.spacing(2, 1)
      },
      display: "flex",
      alignItems: "start"
    },
    i.icon
  );
  return /* @__PURE__ */ t.createElement(
    r,
    {
      display: "flex",
      sx: {
        backgroundColor: i.bgColor,
        color: n.palette.text.primary,
        border: `1px solid ${i.color}`,
        borderRadius: "4px",
        width: "100%"
      },
      id: e.id,
      position: "relative",
      ref: h,
      role: "status",
      "aria-label": e["aria-label"]
    },
    /* @__PURE__ */ t.createElement(R, null),
    /* @__PURE__ */ t.createElement(
      r,
      {
        margin: 2,
        sx: { width: "100%", flexGrow: 1, minWidth: 0 },
        ref: E
      },
      e.onClose && /* @__PURE__ */ t.createElement(
        k,
        {
          closeButtonRef: C,
          onClose: e.onClose
        }
      ),
      /* @__PURE__ */ t.createElement(
        z,
        {
          message: e.title,
          shouldWrap: c,
          maxWidth: a - o - parseInt(n.spacing(2))
        }
      ),
      e.description && // The description and title should not exceed past the close button, so a max width must be set
      /* @__PURE__ */ t.createElement(
        I,
        {
          variant: "body1",
          sx: {
            display: "block",
            marginTop: "4px",
            maxWidth: a - o - parseInt(n.spacing(2))
          }
        },
        e.description
      ),
      e.actionOne && /* @__PURE__ */ t.createElement(b, null)
    )
  );
});
export {
  _ as B
};
